import React from "react";
import Hero from "../components/Hero";
import "./RecursosHumanos.css";

export default function RecursosHumanos() {
  return (
    <>
      <Hero
        subtitle="RECURSOS HUMANOS"
        title="Nuestro equipo, nuestra fortaleza"
        description="Capacitación, desarrollo y bienestar para asegurar la calidad del servicio."
        variant="dark"
        align="center"
        height="sm"       
      />

      <main className="rh-page">
        {/* Intro + Foto */}
        <section className="rh-intro">
          <div className="rh-intro-grid">
            <div className="rh-intro-copy">
              <h2 className="rh-title">Para brindar seguridad primero debemos estar seguros de quienes nos representan.</h2>
              <p className="rh-lead">
                Es por ello que la selección de los recursos humanos la realizamos
                a través de un minucioso proceso interno, de manera de garantizar la 
                capacidad técnica, las habilidades psicosociales y las condiciones humanas 
                de los funcionarios, para que estos honren y representen los valores de la 
                empresa, manteniendo siempre una buena presencia, cortesía y un alto nivel de comunicación.                 
              </p>
              <p className="rh-lead">
                <strong>Nuestro centro de capacitación de guardia privada está debidamente 
                    habilitado por el Ministerio del Interior. En él se instruye al personal 
                    para que la tecnología, puesta al servicio de la seguridad, sea realmente 
                    eficaz en cada operativo, gracias a las adecuadas intervenciones de un 
                    personal debidamente instruido.</strong>                  
              </p>
            </div>
          </div>
        </section>
        <section className="rh-intro">
          <div className="rh-intro-grid">
            <figure className="rh-intro-photo">
              <img
                src="/assets/home/oficina_sevicol.webp"
                alt="Equipo trabajando en SEVICOL"
                loading="lazy"
              />
            </figure>
          </div>
        </section>

         {/* CTA final */}
        <section className="rh-cta">
          <div className="rh-cta-box">
            <h3>¿Te gustaría formar parte de SEVICOL?</h3>
            <p>Completá tu postulación y nos pondremos en contacto.</p>
            <a className="btn-rh primary" href="/formularioCV">
              <i className="bi bi-file-earmark-arrow-up" /> Enviar CV
            </a>
          </div>
        </section>
      </main>
    </>
  );
}
